module.exports = __webpack_public_path__ + "static/media/card-trailblazer1-square.beefc1ca.png";